export interface CategoryType {
  name: string;
  i18n: {
    en: string;
    de: string;
    fr: string;
    it: string;
  };
}

export const adaptCategories = (categories: CategoryType[]) => {
  return categories.map((category: CategoryType) => category.name);
};
